import React, { useCallback } from 'react';
import { Table } from '@devexpress/dx-react-grid-material-ui';
import { push } from 'connected-react-router';
import { useDispatch } from "react-redux";



const ClientReportTableRow = (props) => {
	const id       = props.row.urpt_id,
		  dispatch = useDispatch();

	const handleNavigate = useCallback(() => {
		dispatch(push(`/reports/edit/${id}`));
	}, [ dispatch, id ]);


	return (
		<Table.Row
			{...props}
			style={{
				cursor: 'pointer',
			}}
			onClick={handleNavigate}
		/>
	);
};


export default ClientReportTableRow;
